<template>
  <div class="priority-item queue-failed">
    <div class="d-flex align-items-center gap-50">
      <i class="far fa-times queue-icon lh-inherit"></i>
      <h2>{{ 'Task not found' | trans }}</h2>
    </div>
    <p>
      {{ 'The task you are looking for was not found.' | trans }}
    </p>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import {
  registerPaymentModalHelper
} from "../../../../../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper";
import user from "../../../mixins/user.mixin";

export default {
  name: "QueueNotFound",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
    user,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openPremiumModal() {
      registerPaymentModalHelper.openUpgrade().then(() => {
        this.modalToShow = null;
      });
    },
  },
  computed: {
  }
};
</script>
<style lang="scss">

</style>
